import { PersonName } from "./person-name/ui/person-name";
import { PersonNameLink } from "./person-name-link/person-name-link";
import { PersonNameColumn } from "./person-name-column/ui/person-name-column";
import { PersonFirstName } from "./first-name/person-first-name";
import { PersonMiddleName } from "./middle-name/person-middle-name";
import { PersonLastName } from "./last-name/person-last-name";
import { PersonLabel } from "./person-label/ui/person-label";
import { PersonCommentLabel } from "./person-comment-label/person-comment-label";
import { PersonAvatar } from "./person-avatar/ui/person-avatar";
import { PersonEmail } from "./email/person-email";
import { PersonEmail as PersonEmailButton } from "./person-email/ui/person-email";
import { PersonPhone } from "./person-phone/ui/person-phone";
import { PersonDateOfBirth } from "./date-of-birth/person-date-of-birth";
import { PersonAge } from "./age/person-age";
import { PersonSex } from "./sex/person-sex";
import { PersonType } from "./type/person-type";
import { PersonEmployeeNumber } from "./employee-number/person-employee-number";
import { PersonWorkTimeInCompany } from "./work-time-in-company/person-work-time-in-company";
import { PersonProbationPeriodDueDate } from "./probation-period-due-date/person-probation-period-due-date";
import { PersonNationalIdentifier } from "./national-identifier/person-national-identifier";
import { PersonPositionAndOrganizationColumn } from "./person-position-and-organization-column/ui/person-position-and-organization-column";
import { PersonPosition } from "../company-structure/person-position/ui/person-position";
import { PersonDepartment } from "../company-structure/person-department/ui/person-department";

/**
 * Поля и представления человека, каждое своим компонентом: показ поля решается один
 * раз здесь, а не на каждой странице заново. Подкомпонент принимает сущность целиком —
 * `<Person.Name data={person} />`, — поэтому вызывающему не нужно знать, из какого
 * вложенного поля собирается значение.
 *
 * Рядом с полями лежат составные представления человека — `Label`, `NameColumn`,
 * `CommentLabel`, `PositionAndOrganization`: это те же данные человека, но в готовой
 * раскладке, которая повторяется в таблицах, карточках и комментариях.
 *
 * `Position` и `Department` показывают должность и подразделение человека, поэтому
 * живут здесь, хотя сами компоненты лежат в сущности оргструктуры.
 */
export const Person = {
  Name: PersonName,
  NameLink: PersonNameLink,
  NameColumn: PersonNameColumn,
  // `Name` собирает имя целиком по выбранному формату, а `FirstName`, `MiddleName` и
  // `LastName` показывают части имени по одной — так их показывает анкета, где каждая
  // часть стоит своей строкой и закрывается защитой отдельно.
  FirstName: PersonFirstName,
  MiddleName: PersonMiddleName,
  LastName: PersonLastName,
  Label: PersonLabel,
  CommentLabel: PersonCommentLabel,
  Avatar: PersonAvatar,
  Email: PersonEmail,
  // `Email` показывает почту текстом и под защитой токена, а `EmailButton` и
  // `PhoneButton` — это чипы-ссылки `mailto:`/`tel:`, то есть действие, а не показ
  // значения. Имена разведены, потому что подменять одно другим нельзя.
  EmailButton: PersonEmailButton,
  PhoneButton: PersonPhone,
  DateOfBirth: PersonDateOfBirth,
  Age: PersonAge,
  Sex: PersonSex,
  EmployeeNumber: PersonEmployeeNumber,
  Type: PersonType,
  WorkTimeInCompany: PersonWorkTimeInCompany,
  ProbationPeriodDueDate: PersonProbationPeriodDueDate,
  NationalIdentifier: PersonNationalIdentifier,
  PositionAndOrganization: PersonPositionAndOrganizationColumn,
  Position: PersonPosition,
  Department: PersonDepartment,
};
